module.exports = __webpack_public_path__ + "img/Portal.c8081ec6.svg";